module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "ChTitle",
    attrs: {
      "id": "ch25"
    }
  }, [_c('a', {
    attrs: {
      "id": "ch25a"
    }
  }), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents#rch25"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("NORA’S NOTIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', [_c('i', [_vm._v("Writer and film director Nora Ephron (1949–2012) was the acerbic wit behind")]), _vm._v(" When Harry Met Sally, Julie and Julia, Heartburn, "), _c('i', [_vm._v("and many other books and movies.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("“It’s true that men who cry are sensitive to and in touch with feelings, but the only feelings they tend to be in touch with are their own.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_vm._v("“When your children are teenagers, it’s important to have a dog so that someone in the house is happy to see you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_vm._v("“I don’t think any day is worth living without thinking about what you’re going to eat next at all times.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_vm._v("“I look as young as a person can look given how old I am.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_vm._v("“A successful parent is one who raises a child who grows up and is able to pay for his or her own psychoanalysis.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_vm._v("“In my sex fantasy, nobody ever loves me for my mind.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_vm._v("“The desire to get married is a basic and primal instinct. It’s followed by another basic and primal instinct: the desire to be single again.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_vm._v("“Never marry a man you wouldn’t want to be divorced from.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_vm._v("“Insane people are always sure that they’re fine. It is only the sane people who are willing to admit that they’re crazy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_vm._v("“My mother was a good cook, but what she believed about cooking is that if you worked hard and prospered, someone else would do it for you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_vm._v("“Oh, how I regret not having worn a bikini the entire time I was 26. If anyone young is reading this, go put on a bikini, and don’t take it off until you’re 34.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_vm._v("“There’s a reason why 40, 50, and 60 don’t look the way they used to, and it’s not because of feminism, or better living through exercise. It’s because of hair dye.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_vm._v("“If pregnancy were a book they would cut out the last two chapters.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_vm._v("“You can’t retrieve your life (unless you’re on Wikipedia, in which case you can retrieve an inaccurate version of it).”")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center7"
  }, [_c('span', [_c('b', [_vm._v("In gangster slang, a fixed boxing match is called a “barney.”")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bef6b286","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter025.vue
// module id = 153
// module chunks = 0